module.exports = __webpack_public_path__ + "img/Dach.cbccfc94.jpg";